import React from 'react';
import './header.css';

const Header = () => {
  return (
    <div className="header section__padding" id="home">
      <div className="header-content">
        <h1 className="gradient__text">Welcome To My Portfolio</h1>
        <p>I'm Denis, a Full-stack software developer in the automotive industry with a creative background in Design. I’m detail-oriented, motivated, and always eager to learn something new.
        </p>
      </div>
      <div className="header-image">
        <img src="https://res.cloudinary.com/diozchjq4/image/upload/v1662284246/portfolio/ai.e753fe6e801fc6fddc1f-min_na68v8.png"  alt="logo"/>
      </div>
    </div>
  );
};

export default Header;
